"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _react = _interopRequireWildcard(require("react")),
    _commentsContext = _interopRequireDefault(require("../../../contexts/commentsContext")),
    _components = require("../components");

function CommentPopover(_ref) {
  var id = _ref.id,
      children = _ref.children,
      commentId = _ref.commentId,
      CommentPopoverComponent = commentId ? _components.EditComment : _components.AddComment;
  return _react["default"].createElement(_commentsContext["default"].Consumer, null, function (_ref2) {
    var _ref2$state = _ref2.state,
        comments = _ref2$state.comments,
        commentModalId = _ref2$state.commentModalId,
        commentModalProps = _ref2$state.commentModalProps,
        modalTarget = _ref2$state.modalTarget,
        filterByMetadataFlag = _ref2$state.filterByMetadataFlag,
        isReadOnly = _ref2$state.isReadOnly,
        canResolveComment = _ref2$state.canResolveComment,
        resourceOrganisationId = _ref2$state.resourceOrganisationId,
        _ref2$actions = _ref2.actions,
        deleteComment = _ref2$actions.deleteComment,
        updateComment = _ref2$actions.updateComment,
        createComment = _ref2$actions.createComment,
        createReply = _ref2$actions.createReply,
        deleteReply = _ref2$actions.deleteReply,
        updateViewers = _ref2$actions.updateViewers,
        getUserColor = _ref2$actions.getUserColor,
        closePopover = _ref2$actions.closePopover;
    if (!commentModalId || commentModalId !== id) return children;
    var targetElement = document.querySelector(modalTarget),
        appendTarget = targetElement || document.querySelector("body");
    return _react["default"].createElement(CommentPopoverComponent, (0, _extends2["default"])({
      filterByMetadataFlag: filterByMetadataFlag,
      createComment: createComment,
      createReply: createReply,
      updateComment: updateComment,
      deleteComment: deleteComment,
      deleteReply: deleteReply,
      updateViewers: updateViewers,
      comment: comments.get(commentId),
      getUserColor: getUserColor,
      closePopover: closePopover,
      appendTarget: appendTarget,
      isReadOnly: isReadOnly,
      canResolveComment: canResolveComment,
      resourceOrganisationId: resourceOrganisationId
    }, commentModalProps), children || null);
  });
}

var _default = (0, _react.memo)(CommentPopover);

exports["default"] = _default;